import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type { TrackerApi, TrackerApiRequest, TrackerApiResponse } from '../tracker-api.ts';
import { coreTelecomApiUrlPrefix } from '../../../domain-config';

@injectable()
export class TrackerApiImpl extends PsHttpService implements TrackerApi {
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async trackEvent(data: TrackerApiRequest): Promise<TrackerApiResponse> {
        const res = await this.post<PatSnapSuccessResponseData<any>>({
            url: '/tracking/add',
            data,
        });

        return res.data;
    }
}
